'use client'

import { useState } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useSession } from '@marketplace-web/shared/session-data'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'

import {
  getFeedbackProblemOptions,
  sendFeedbackProblemFeedback,
  transformFeedbackProblemOptions,
  FeedbackOptionsModel,
} from '@marketplace-web/conversation-feedback/conversation-feedback-data'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import DenyHelpCenterFeedbackModal from '../DenyHelpCenterFeedbackModal'

const DenyHelpCenterFeedback = ({
  primary,
  title,
  inverse,
  theme,
  size,
}: Partial<ConversationActionProps>) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [problemOptions, setProblemOptions] = useState<Array<FeedbackOptionsModel>>([])

  const userId = useSession().user?.id
  const { conversation } = useConversationContext()
  const conversationId = conversation?.id

  const { fetch, isLoading: isFetchProblemOptionsLoading } = useFetch(getFeedbackProblemOptions)

  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  const handleOpenModal = async () => {
    if (!conversationId || !userId) return

    const response = await fetch(userId, conversationId.toString())
    if (response.data?.problem_options) {
      setProblemOptions(transformFeedbackProblemOptions(response.data.problem_options))
      setIsModalOpen(true)
    }
  }

  function handleCloseModal() {
    setIsModalOpen(false)
  }

  async function handleSubmit(selectedOption: number | undefined, message: string) {
    if (!conversationId || !userId || !selectedOption) return

    setIsSubmitting(true)
    await sendFeedbackProblemFeedback({
      userId,
      conversationId: Number(conversationId),
      message,
      problemOptionId: selectedOption,
      helpCenterSessionId,
    })
    setIsSubmitting(false)
    setIsModalOpen(false)
  }

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        isLoading={isFetchProblemOptionsLoading || isSubmitting}
        onClick={handleOpenModal}
      />
      <DenyHelpCenterFeedbackModal
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        options={problemOptions}
        isOpen={isModalOpen}
      />
    </>
  )
}

export default DenyHelpCenterFeedback
